module.exports = __webpack_public_path__ + "static/img/dd-banner-05.88b156c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-banner-05.png
// module id = qsgT
// module chunks = 1